import { render, staticRenderFns } from "./ChartWorkGoal.vue?vue&type=template&id=08f00973&scoped=true"
import script from "./ChartWorkGoal.vue?vue&type=script&lang=ts"
export * from "./ChartWorkGoal.vue?vue&type=script&lang=ts"
import style0 from "./ChartWorkGoal.vue?vue&type=style&index=0&id=08f00973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f00973",
  null
  
)

export default component.exports